import { render, staticRenderFns } from "./freightManagement.vue?vue&type=template&id=3f14611a&scoped=true&"
import script from "./freightManagement.vue?vue&type=script&lang=js&"
export * from "./freightManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f14611a",
  null
  
)

export default component.exports